import WorkFlow from './container';

export default WorkFlow;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/index.js